import { render, staticRenderFns } from "./exploded-bom.vue?vue&type=template&id=546d01fc&"
import script from "./exploded-bom.vue?vue&type=script&lang=js&"
export * from "./exploded-bom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546d01fc')) {
      api.createRecord('546d01fc', component.options)
    } else {
      api.reload('546d01fc', component.options)
    }
    module.hot.accept("./exploded-bom.vue?vue&type=template&id=546d01fc&", function () {
      api.rerender('546d01fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/exploded-bom.vue"
export default component.exports